import TextArea from "antd/es/input/TextArea"
import { useEffect, useState, useCallback } from "react"
import { getTranslated, validateAttr } from "../../utils/CommonUtils"
import { ExclamationCircleFilled } from "@ant-design/icons"
import { ERROR_RED } from "../../styles/styleUtils"
import { Tooltip } from "antd"
import { applyROAccess } from "../../utils/ValidationUtils"
import { useSelector } from "react-redux"
import debounce from 'lodash.debounce';

const UMCTextArea = (props) => {

    const [value, setValue] = useState(null)
    const [attrStatus, setAttrStatus] = useState("")
    const [readOnly, setReadOnly] = useState(false)
    const dict = useSelector(state => state.common.dict)

    useEffect(() => {
        setValue(props.value)
    }, [props.value])

    useEffect(() => {
        setReadOnly(props.isReadOnly || applyROAccess(props.access, props.actionMode))
    }, [props.access, props.actionMode, props.isReadOnly])

    useEffect(() => {
        if (props.validateState && value !== null) {
            setAttrStatus(validateAttr(props, value))
        }
    }, [props.validateState])

    //debounce logic to reduce number of schema change checking
    // const debouncedSchemaChange = useCallback(
    //     debounce((val) => {
    //         if (!readOnly && props.value !== val) {
    //             props.handleSchemaDataChange?.(props, val);
    //         }
    //     }, 300),
    //     [props.value, readOnly]
    // );
    
    const handleChange = (event) => {
        const newValue = event?.target?.value
        const attrStatus = validateAttr(props, newValue)

        setAttrStatus(attrStatus)
        setValue(newValue)
        props.handleChange && props.handleChange(newValue, props.id)
        props.handleSchemaDataChange && props.handleSchemaDataChange(props,newValue)// && debouncedSchemaChange(newValue)
    }

    const handleBlur = () => {
        if (!readOnly && props.value !== value) {
            props.handleBlur && props.handleBlur(value, props.id)
        }
    }

    return <span style={{ display: attrStatus.errorMsg ? "flex" : "" }} className={`attr-wrap ${readOnly ? "read-only" : ""}`}>
        <TextArea
            {...props}
            status={attrStatus?.status}
            tabIndex={readOnly && -1}
            value={value}
            readOnly={readOnly}
            className={`${props.className} ${props.parentClassName}`}
            onChange={(e) => handleChange(e)}
            onBlur={() => handleBlur()} //{() => props.handleSchemaDataChange && props.handleSchemaDataChange(props, value)}
            placeholder={getTranslated(dict, props.placeholder)}
            autoSize={props.autoSize || {
                minRows: 1,
                maxRows: 3,
            }}
        />
        {attrStatus.errorMsg ? <Tooltip title={getTranslated(dict, attrStatus.errorMsg)}><ExclamationCircleFilled style={{ color: ERROR_RED, paddingLeft: "5px" }} /></Tooltip> : <></>}
    </span>
}

export default UMCTextArea